import React from "react";
import { Field, TextInput } from "@streeteasy/design-system";
import { TextArea } from "@streeteasy/design-system/form/TextAreaField";
import { Formik } from "formik";
import { func, string } from "prop-types";

import { useAgentMatchData } from "../../redux/hooks/agentMatchHooks";
import {
  useContactFormBehavior,
  useContactFormData
} from "../../redux/hooks/contactFormHooks";
import { agentContactForm } from "../../schemas/agentContactForm";
import * as S from "./styled";

const AgentContactForm = ({ className, handleCancelClick }) => {
  const {
    email,
    errors: externalValidationErrors,
    name,
    phoneNumber
  } = useContactFormData();
  const { brokerageAddress } = useAgentMatchData();
  const { createListingAgentMatchConnection } = useContactFormBehavior();

  return (
    <S.FormContainer className={className}>
      <Formik
        initialValues={{
          email,
          name,
          phoneNumber,
          message: "Hi, I'd like to discuss selling my home."
        }}
        onSubmit={values => {
          createListingAgentMatchConnection(values);

          return false;
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={agentContactForm}
      >
        {({ errors, handleChange, handleSubmit, isSubmitting, values }) => (
          <S.Form>
            <div>
              <S.FieldContainer>
                <Field
                  error={errors.name}
                  hint="required"
                  id="name"
                  isValid={!errors.name}
                  label="Name"
                >
                  <TextInput
                    name="name"
                    onChange={handleChange}
                    required
                    type="text"
                    value={values.name}
                  />
                </Field>
              </S.FieldContainer>
              <S.FieldContainer>
                <Field
                  error={
                    errors.phoneNumber || externalValidationErrors?.phoneNumber
                  }
                  hint="required"
                  id="phoneNumber"
                  isValid={
                    !errors.phoneNumber &&
                    !externalValidationErrors?.phoneNumber
                  }
                  label="Phone"
                  onChange={handleChange}
                >
                  <TextInput
                    name="phoneNumber"
                    onChange={handleChange}
                    required
                    type="text"
                    value={values.phoneNumber}
                  />
                </Field>
              </S.FieldContainer>
              <S.FieldContainer>
                <Field
                  error={errors.email || externalValidationErrors?.email}
                  hint="required"
                  id="email"
                  isValid={!errors.email && !externalValidationErrors?.email}
                  label="Email"
                >
                  <TextInput
                    name="email"
                    onChange={handleChange}
                    required
                    type="text"
                    value={values.email}
                  />
                </Field>
              </S.FieldContainer>
              <S.FieldContainer>
                <Field
                  error={errors.message}
                  hint="required"
                  id="message"
                  isValid={!errors.message}
                  label="Message"
                >
                  <TextArea
                    name="message"
                    onChange={handleChange}
                    required
                    value={values.message}
                  />
                </Field>
              </S.FieldContainer>
              <S.BrokerageAddress>
                Broker at {brokerageAddress}
              </S.BrokerageAddress>
            </div>
            <S.TermsMessage />
            <S.ButtonContainer>
              <S.CancelButton
                disabled={isSubmitting}
                onClick={handleCancelClick}
                type="button"
              >
                Cancel
              </S.CancelButton>
              <S.SubmitButton
                disabled={isSubmitting}
                onClick={handleSubmit}
                type="submit"
              >
                Send Message
              </S.SubmitButton>
            </S.ButtonContainer>
          </S.Form>
        )}
      </Formik>
    </S.FormContainer>
  );
};

AgentContactForm.propTypes = {
  className: string,
  handleCancelClick: func.isRequired
};

AgentContactForm.defaultProps = {
  className: null
};

export default AgentContactForm;
